import { useParamsId } from 'app/agriculture/charts/useParamsId';
import { useEntity } from 'app/agriculture/queries/entities/useEntity';
import { PolyLineEntityTypes } from 'app/agriculture/models/Entities';
import { PolylineLengthComponent } from 'app/agriculture/forms/components/polyline_length_component';

interface PolygonContentProps {
    infraType: (typeof PolyLineEntityTypes)[number];
}

export function LineStringContent({ infraType }: PolygonContentProps) {
    const id = useParamsId();
    const { geometry } = useEntity({ entityId: id, entityType: infraType });

    return (
        <PolylineLengthComponent
            id="linestring-entity-length"
            noun="Length"
            line={geometry.coordinates}
        />
    );
}
